export default __webpack_public_path__ + "static/media/Blenders-Category-Offer.5bbbae15.png";